const LISTING_PAGES = {
    DEFAULT: 5,
    EXTENDED: 6,
};

module.exports = { LISTING_PAGES };
